import { useState } from 'react'
import { Box, Grid, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

type AccordionProps = {
  children: React.ReactNode
  title: string
}

const Accordion = ({ children, title }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleIsOpen = () => setIsOpen(prevIsOpen => !prevIsOpen)

  return (
    <Box
      border={`1px solid ${Color.smoke.darker}`}
      borderRadius="8px"
      mb="1em"
      p={{ sm: '2.5em 2em', xs: '2.5em 1.5em' }}
      onClick={toggleIsOpen}
      sx={{ cursor: 'pointer' }}
    >
      <Grid container wrap="nowrap" justifyContent="space-between" alignItems="baseline">
        <Typography variant="h5" component="h3" m="0" itemProp="name">
          {title}
        </Typography>
        <Grid item flexShrink="0" ml="1em">
          <CloudflareImage src="/images/icon/caret-down.svg" width={16} height={10} />
        </Grid>
      </Grid>
      <Box pt="1em" display={isOpen ? undefined : 'none'}>
        {children}
      </Box>
    </Box>
  )
}

export default Accordion
